import { useState } from 'react';
import Button from '@/components/primitives/Button.jsx';
import Dialog from '@/components/patterns/Dialog.jsx';
import toastManager from '@/lib/toast/toastManager.js';
import { deleteMember, getMembers } from '@/redux/requests/membersRequests.js';

/** Confirms removing a person (or cancelling their invite) and says what they lose. */
const RemoveMemberDialog = ({ member, organizationName, onOpenChange }) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState('');
  const name = member?.isPending ? member?.email : member?.name || member?.email;

  const handleRemove = async () => {
    setIsRemoving(true);
    setError('');
    const res = await deleteMember({ userId: member.userId });
    setIsRemoving(false);

    if (res?.success === false) {
      setError(res.message || 'This person could not be removed.');
      return;
    }

    await getMembers();
    toastManager.add({ type: 'success', title: member.isPending ? 'Invite cancelled' : `${name} removed` });
    onOpenChange(false);
  };

  return (
    <Dialog
      open={Boolean(member)}
      onOpenChange={onOpenChange}
      title={member?.isPending ? `Cancel the invite for ${name}?` : `Remove ${name}?`}
      description={member?.isPending ? 'The link in their email stops working.' : `They lose access to ${organizationName} right away. Their own connections to apps are removed from it too.`}
      footer={
        <>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Keep
          </Button>
          <Button variant="danger" loading={isRemoving} onClick={handleRemove}>
            {member?.isPending ? 'Cancel invite' : 'Remove member'}
          </Button>
        </>
      }>
      {error && <p className="settings-error">{error}</p>}
    </Dialog>
  );
};

export default RemoveMemberDialog;
